export const getRandomCensoredImage = () => {
  const i = Math.floor(Math.random() * 14) + 1;
  return `${import.meta.env.VITE_MEDIA_CONTENT_HOST}/content/images_mysql/censored/kot${i}.jpg`;
};

export const getCensoredVideoSource = () => {
  return `${import.meta.env.VITE_MEDIA_CONTENT_HOST}/upload/CMS/freearea_video/recoded/,360/censored_video.mp4,480/censored_video.mp4,720/censored_video.mp4,1080/censored_video.mp4,.urlset/master.m3u8`;
};
